import { Tables } from "@/lib/supabase/supabase_types_override";
import { isEqual } from "lodash";
import { extractFieldProperties } from "./extractFieldProperties";
import { QuestionFieldOptionsChangedChange } from "@/features/survey_sync/types/syncCheckResult";
// import { QuestionFieldOptions } from "@/features/question/types/fieldOptions"; // Unused

export const checkIfQuestionFieldPropertiesChanged = (
  question: Tables<"question">,
  templateQuestion: Tables<"survey_bank_question_bank">,
): QuestionFieldOptionsChangedChange | false => {
  // ! Extract all question field properties but field_options because these are being validated separately
  const {field_options: qFO_,...questionFieldOptions} = extractFieldProperties(question);
  const {field_options: tFO_,...templateQuestionFieldOptions} = extractFieldProperties(templateQuestion);

  const hasChanged = !isEqual(questionFieldOptions, templateQuestionFieldOptions);

  if (hasChanged) {
    // Find modified options by comparing the field option objects
    const modifiedOptions: Array<{
      option: string;
      value: unknown;
    }> = [];

    // Compare each field option property
    Object.keys(questionFieldOptions).forEach(key => {
      const questionValue = (questionFieldOptions as any)[key];
      const templateValue = (templateQuestionFieldOptions as any)[key];

      if (!isEqual(questionValue, templateValue)) {
        modifiedOptions.push({
          option: key,
          value: questionValue,
        });
      }
    });

    // Since we can't determine if the change was made in template or instance,
    // we'll use the NonDeterministicChangeType pattern
    return {
      type: "QUESTION_FIELD_PROPERTIES_CHANGED",
      context: {
        instanceFieldOptions: questionFieldOptions,
        templateFieldOptions: templateQuestionFieldOptions,
        modifiedOptions,
      },
    };
  }

  return false;
};